import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg, PRODUCT_TYPES } from "@/lib/api";

export const NewProductDialog = ({ trigger, defaultCategory }) => {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [cats, setCats] = useState([]);
  const [f, setF] = useState({ title: "", category_id: defaultCategory || "", product_type: "guide" });

  useEffect(() => {
    if (open) api.get("/categories").then((r) => setCats(r.data));
  }, [open]);

  const create = async (e) => {
    e.preventDefault();
    if (!f.category_id) return toast.error("Choose a category");
    try {
      const r = await api.post("/products", { ...f, title: f.title || "Untitled title" });
      setOpen(false);
      nav(`/products/${r.data.id}`);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="bg-[#FFFDF9] rounded-none" data-testid="new-product-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-normal">Begin a new title</DialogTitle>
        </DialogHeader>
        <form onSubmit={create} className="space-y-4">
          <div>
            <Label>Working title</Label>
            <Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Leave blank and AI will suggest one" className="mt-2" data-testid="new-product-title-input" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Category</Label>
              <Select value={f.category_id} onValueChange={(v) => setF({ ...f, category_id: v })}>
                <SelectTrigger className="mt-2" data-testid="new-product-category-select"><SelectValue placeholder="Choose" /></SelectTrigger>
                <SelectContent>
                  {cats.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`category-option-${c.id}`}>{c.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Type</Label>
              <Select value={f.product_type} onValueChange={(v) => setF({ ...f, product_type: v })}>
                <SelectTrigger className="mt-2" data-testid="new-product-type-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {PRODUCT_TYPES.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          </div>
          <Button type="submit" className="w-full rounded-none" data-testid="new-product-create-btn">Open in the studio</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
